import styled from 'styled-components';
import { Heading as H } from 'grommet';

export const Heading = styled(H as any)`
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: ${p => (p.color ? p.color : p.theme.gray.lightest)};
  margin: 0;
  display: block;
  text-align: ${(p: { center?: boolean }) => p.center && 'center'};
  max-width: inherit;
`;
